import { Component, Inject, NgZone, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { TermsComponent } from './modal/terms/terms.component';
import { messages } from '../../../../../common/messages'
import { states } from '../../../../../common/states';
import { url } from '../../../../../common/apiConstants';
import { education } from '../../../../../common/education';
import { speciality, specialtyIntakeForms } from '../../../../../common/specialityList'
import { countryList } from '../../../../../common/country'
import { debounce } from 'lodash'
import { ApiService } from 'src/app/services/api.service';
import { UtilityService } from 'src/app/services/utility.service';
import { FeatureFlagService } from 'src/app/services/feature-flag.service';
import { MatSelect } from '@angular/material/select';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import icVisibility from '@iconify/icons-ic/twotone-visibility';
import icVisibilityOff from '@iconify/icons-ic/twotone-visibility-off';
import { regex ,EmailNoWhitespaceValidator} from '../../../../../common/regex';
declare const google;
export interface Speciality {
}

export const SPECIALITIES: Speciality[] = speciality

@Component({
    selector: 'app-sign-up',
    templateUrl: './sign-up.component.html',
    styleUrls: ['./sign-up.component.scss'],
    standalone: false
})
export class SpecialistSignUpComponent implements OnInit {

  //variables
  assets = environment.assets;
  step: number = 1;
  signupFormGroup: any
  passwordFormGroup: any
  message: any;
  statesList: any = [];
  urlList: any;
  countries
  selectedState: string = '';
  userId: any;
  educationsList: string[] = []
  hide = true;
  hide1 = true;
  hide2 = true;
  chide = true;
  icVisibility = icVisibility;
  icVisibilityOff = icVisibilityOff;
  address = new FormControl("");
  locationDetails: any;
  showDocPreview: boolean = false
  minDate = new Date();
  licenseExpiryDate = new FormControl("", [Validators.required]);
  licenseValidityFlag: boolean = true

  /** list of specialities */
  protected specialities: Speciality[] = SPECIALITIES;

  /** total number of available entries */
  public allSpecialitySize = SPECIALITIES.length;

  /** control for the selected specialities for multi-selection */
  public specialityMultiCtrl: FormControl = new FormControl([], [Validators.required]);

  /** control for the MatSelect filter keyword multi-selection */
  public specialityMultiFilterCtrl: FormControl = new FormControl();

  /** list of specialities filtered by search keyword */
  public filteredSpecialitiesMulti: ReplaySubject<Speciality[]> = new ReplaySubject<Speciality[]>(1);

  /** Subject that emits when the component has been destroyed. */
  protected _onDestroy = new Subject<void>();

  //view child
  @ViewChild('lowerCase') private lowerCase: any;
  @ViewChild('upperCase') private upperCase: any;
  @ViewChild('oneNumeric') private oneNumeric: any;
  @ViewChild('minLength') private minLength: any;
  @ViewChild('symbol') private symbol: any;
  @ViewChild('multiSelect', { static: true }) multiSelect: any;


  re = /^(([^<>()\[\]\\.,:\s@"]+(\.[^<>()\[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  pwdPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-+_!@#$%^&*., ?])[A-Za-z\d-+_!@#$%^&*., ?]{8,16}$/
  lowerCaseRegex = /.*[a-z].*/
  upperCaseRegex = /.*[A-Z].*/
  oneNumericRegex = /.*\d.*/
  oneSymbol = /(?=.*[-+_!@#$%^&*., ?]).+/

  //FormControl
  // education = new FormControl([], [Validators.required]);
  otherEducation = new FormControl('', [Validators.pattern(/^[-a-zA-Z-()@&$]+(\s+[-a-zA-Z-()@&$]+)*$/)]);
  otherSpeciality = new FormControl('');
  malpracticeInsuranceExpiryDate = new FormControl('', [Validators.required]);
  imageUploadError: any = '';
  file: any;
  fileName: any = '';
  imageSrc: any = '';
  action: string;

  education = new FormControl<string[]>([], [Validators.required]);
  get isEducationOther(): boolean {
    const value = this.education.value ?? [];
    return Array.isArray(value) && value.length > 0 && value.includes('Other');
  }


  constructor(
    public dialog: MatDialog,
    public router: Router,
    private _formBuilder: FormBuilder,
    private apiService: ApiService,
    private Utility: UtilityService,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document,
    private renderer2: Renderer2,
    private ngZone: NgZone,
    private featureFlagService: FeatureFlagService
  ) { }

  ngOnInit(): void {

    this.setupSignUpForm();
    // this.loadAutoComplete();

    const tokens = this.route.snapshot.params.token;


    this.message = messages
    // this.statesList = states
    this.urlList = url
    this.educationsList = education
    this.countries = countryList

    // Filter specialties based on feature flag
    if (this.featureFlagService.isSpecialtyIntakeEnabled()) {
      // When specialty intake is enabled, show only specialties with intake forms
      this.specialities = specialtyIntakeForms.map(s => s as any);
    } else {
      // When disabled, show all specialties (default behavior)
      this.specialities = SPECIALITIES;
    }

    this.passwordFormGroup = this._formBuilder.group({
      password: new FormControl("", [
        Validators.required,
        Validators.pattern(this.pwdPattern),
        this.noWhitespaceValidator as ValidatorFn
      ]),
      confirmPassword: new FormControl(''),
    }, {
      validator: this.comparePassword
    })

    // load the initial speciality list
    this.filteredSpecialitiesMulti.next(this.specialities.slice());

    // listen for search field value changes
    this.specialityMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBanksMulti();
      });

    if (tokens) {
      this.verifyEmail(tokens)
    }


  }

  ngAfterViewInit() {
    this.setInitialValue();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  // Method to display states list as per country choosen
  setStateValue(event) {
    this.signupFormGroup.controls["otherCountry"].setValidators(null)
      this.signupFormGroup.controls["otherCountry"].updateValueAndValidity();
    let country = event.value
    if (country === 'Canada') {
      this.statesList = states.canadianStates
      this.signupFormGroup.patchValue({
        licenseState: ''
      })

    } else if (country === 'United States') {
      this.statesList = states.UnitedStates
      this.signupFormGroup.patchValue({
        licenseState: ''
      })
    } else {
      this.signupFormGroup.patchValue({
        licenseState: 'Other'
      })
      this.signupFormGroup.controls["otherCountry"].setValidators([Validators.required, Validators.pattern(/^([a-zA-Z0-9]+\s)*[a-zA-Z0-9]+$/)])
      this.signupFormGroup.controls["otherCountry"].updateValueAndValidity();
      this.signupFormGroup.controls["otherLicenseState"].setValidators([Validators.required, Validators.pattern(/^([a-zA-Z0-9]+\s)*[a-zA-Z0-9]+$/)])
      this.signupFormGroup.controls["otherLicenseState"].updateValueAndValidity();
    }
  }

  private loadAutoComplete() {
    const url = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAuxw_Vyo9oWGyjEuDk34SykzfeIfeXfd0&libraries=places&v=weekly';
    this.loadScript(url).then(() => this.initAutocomplete());
  }

  private loadScript(url) {
    return new Promise((resolve, reject) => {
      const script = this.renderer2.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      script.text = ``;
      script.async = true;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      this.renderer2.appendChild(this.document.head, script);
    })
  }

  initAutocomplete() {
    const input = document.getElementById("txtSearchPlaces") as HTMLInputElement;
    const autocomplete = new google.maps.places.Autocomplete(input);
    autocomplete.setFields([
      "address_components",
      "geometry",
      "icon",
      "name"
    ]);
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();

      if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        alert('No details available for input:' + input.value);
        return;
      } else {
        this.ngZone.run(() => {
          this.locationDetails = this.Utility.getAllLocationDetails(place)
          this.signupFormGroup.controls["country"].setValue(this.locationDetails.country);
          // this.signupFormGroup.controls["practiceAddress"].setValue(this.locationDetails.address);
          this.signupFormGroup.controls["stateOfPractice"].setValue(this.locationDetails.state);
        })

      }
    });
  }
  protected setInitialValue() {
    this.filteredSpecialitiesMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        // setting the compareWith property to a comparison function
        // triggers initializing the selection according to the initial value of
        // the form control (i.e. _initializeSelection())
        // this needs to be done after the filteredspeciality are loaded initially
        // and after the mat-option elements are available
        this.multiSelect.compareWith = (a: Speciality, b: Speciality) => a && b && a === b;
      });
  }

  protected filterBanksMulti() {
    if (!this.specialities) {
      return;
    }
    // get the search keyword
    let search = this.specialityMultiFilterCtrl.value;
    if (!search) {
      this.filteredSpecialitiesMulti.next(this.specialities.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the specialities
    this.filteredSpecialitiesMulti.next(
      this.specialities.filter(bank => bank.toString().toLowerCase().indexOf(search) > -1)
    );
  }

  toggleSelectAll(selectAllValue: any) {
    this.filteredSpecialitiesMulti.pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(val => {
        if (selectAllValue) {
          this.specialityMultiCtrl.patchValue(val);
        } else {
          this.specialityMultiCtrl.patchValue([]);
        }
      });
  }
  // checkLicenseDateValidity() {

  //   if (this.licenseExpiryDate.value) {
  //     this.licenseExpiryDate.setErrors(null);

  //     this.licenseValidityFlag = true

  //   }
  // }


  //setup Sign up form 
  setupSignUpForm() {
    this.signupFormGroup = this._formBuilder.group({
      credentials: ['', Validators.compose([
        Validators.required,
        // this.noWhitespaceValidator,
        // Validators.pattern(/[^,\s?]+/g)
      ])],

      firstName: ['', Validators.compose([
        Validators.required,
        //Validators.pattern("^[a-zA-Z ]*$")
      ]
        )],

      lastName: ['', Validators.compose([
        Validators.required,
      ])],

      // education: ['', Validators.compose([
      //   Validators.required,
      //   Validators.pattern("^[a-zA-Z_ ]*$")])],

      // practiceAddress: ['', Validators.compose([
      //   Validators.required,
      // ])],
      liabilityInsuranceProvider: ['', Validators.compose([
        Validators.required,

      ])],
      country: ['', Validators.compose([
        Validators.required,
      ])],

      otherCountry: [''],

      licenseState: ['', Validators.compose([
        Validators.required,
      ])],
      otherLicenseState: [''],

      licenseNumber: ['', Validators.compose([
        Validators.required,
      ])],

      email: ['', Validators.compose([
        Validators.required,
        EmailNoWhitespaceValidator
      ])],
    })


  }
  //method used to verify Email
  verifyEmail(token: string) {
    this.Utility.setSpinner(true);

    this.apiService.apiRequest("post", "user/verifyEmail", { tokens: token })
      .subscribe((res) => {
        if (res) {
          this.userId = res.data.userId
          this.Utility.openSnackBar(res.data.message, "Ok")
          this.step = 2;
          this.Utility.setSpinner(false);

        }
      }, (err) => {
        this.Utility.setSpinner(false);
        if (err?.status === 400 && err?.error?.status === 'invalidToken') {
          this.Utility.openSnackBar("This verification link is no longer valid. Please use the latest verification email.", "Ok")
        } else {
          this.Utility.openSnackBar("Email verification link expired.", "Ok")
        }
        this.router.navigate(['/404']); // Navigate to 404 page for invalid/expired tokens

      })
  }
  //method called after signup form is filled and user clicks on signup
  submitForm() {

    if (this.fileName != '') {


      this.Utility.setSpinner(true)

      let licenseInfo = {
        licenseNumber: this.signupFormGroup.value.licenseNumber,
        licenseState: this.signupFormGroup.value.licenseState,
        otherLicenseState: this.signupFormGroup.value.otherLicenseState,
        licenseExpiryDate: this.licenseExpiryDate.value

      }
      let fd = new FormData()

      fd.append("credentials", this.signupFormGroup.value.credentials.trim())
      fd.append("firstName", this.signupFormGroup.value.firstName.trim())
      fd.append("lastName", this.signupFormGroup.value.lastName.trim())
      fd.append("email", this.signupFormGroup.value.email.toLowerCase())
      fd.append("country", this.signupFormGroup.value.country)
      fd.append("speciality", JSON.stringify(this.specialityMultiCtrl.value))
      fd.append("education", JSON.stringify(this.education.value))
      fd.append("otherEducation", (this.otherEducation.value || ''))
      fd.append("otherSpeciality", this.otherSpeciality.value || '')
      fd.append("malpracticeInsuranceExpiryDate", this.malpracticeInsuranceExpiryDate.value || '')
      fd.append("liabilityInsuranceProvider", this.signupFormGroup.value.liabilityInsuranceProvider)
      fd.append("licenseInfo", JSON.stringify(licenseInfo))
      fd.append("otherCountry", this.signupFormGroup.value.otherCountry)
      fd.append("userType", 'specialist')

      if (this.file) {
        fd.append("doc", this.file)
      }

      this.apiService.apiRequest("post", this.urlList.routes.signupSpecialist, fd)
        .subscribe((res) => {
          this.Utility.setSpinner(false);
          this.setupSignUpForm();
          this.education.patchValue([])
          this.education.setErrors(null)
          this.specialityMultiCtrl.patchValue([])
          this.address.patchValue("")
          this.specialityMultiCtrl.setErrors(null)
          this.Utility.openSnackBar("A verification email has been been sent to your registered email ID. Please check your Inbox", "Ok")
          this.imageUploadError = ''
          this.imageSrc = ''
          this.malpracticeInsuranceExpiryDate.reset()
          this.licenseExpiryDate.reset()

          this.showDocPreview = false
        }, (err) => {
          this.Utility.setSpinner(false)
        })
    } else {
      this.imageUploadError = "Please upload image driving license/other state issued ID"
    }
    // this.Utility.setSpinner(true);


    // let userDetails = {
    //   firstName: this.signupFormGroup.value.firstName,
    //   lastName: this.signupFormGroup.value.lastName,
    //   credentials: this.signupFormGroup.value.credentials,
    //   education: this.education.value,
    //   speciality: this.specialityMultiCtrl.value,
    //   otherEducation: this.otherEducation.value,
    //   otherSpeciality: this.otherSpeciality.value,
    //   licenseState: this.signupFormGroup.value.licenseState,
    //   otherLicenseState: this.signupFormGroup.value.otherLicenseState,
    //   otherCountry: this.signupFormGroup.value.otherCountry,
    //   country: this.signupFormGroup.value.country,
    //   email: this.signupFormGroup.value.email.toLowerCase(),
    //   licenseNumber: this.signupFormGroup.value.licenseNumber,
    //   userType: "specialist"
    // }

    // this.apiService.apiRequest("post", this.urlList.routes.signupSpecialist, userDetails)
    //   .subscribe((res) => {
    //     this.Utility.setSpinner(false);
    //     this.setupSignUpForm();
    //     this.education.patchValue([])
    //     this.education.setErrors(null)
    //     this.specialityMultiCtrl.patchValue([])
    //     this.address.patchValue("")
    //     this.specialityMultiCtrl.setErrors(null)
    //     this.Utility.openSnackBar("A verification email has been been sent to your registered email ID. Please check your Inbox", "Ok")
    //   }, (err) => {
    //     this.Utility.setSpinner(false);
    //   })
  }

  readImage = (event: any) => {
    let error
    if (event.target.files && event.target.files[0]) {
      error = this.validateFile(event.target.files[0])
      if (error == '') {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = e => this.imageSrc = reader.result;
        reader.readAsDataURL(file);
        this.fileName = event.target.files[0].name
        this.file = event.target.files[0]
        this.showDocPreview = true;
        this.action = ''
      } else {
        this.imageUploadError = error

      }

    }
  }

  validateFile(file) {
    this.imageUploadError = ''
    const allowedExt = ["png", "jpg", "jpeg"]
    const maxfilesize = 8 * 1024 * 1024

    const fileNameArray = file.name.split(".")
    const extension = fileNameArray[fileNameArray.length - 1]

    if (allowedExt.indexOf(extension.toLowerCase()) == -1) {
      return "Allowed Extension are " + allowedExt.join(", ")
    } else if (file.size > maxfilesize) {
      return "File size should not exceed 8 MB."
    } else {
      return ''
    }
  }

  deleteFile() {
    this.showDocPreview = false
    this.fileName = ''
    this.file = ''
  }
  educationChange(event) {
    if (event.includes('Other')) {
      this.otherEducation.setValidators([Validators.required])
      this.otherEducation.updateValueAndValidity()
    } else {
      this.otherEducation.setValidators(null)
      this.otherEducation.updateValueAndValidity()

    }
  }

  specialityChange(event) {

    if (event.includes('Other')) {
      this.otherSpeciality.setValidators([Validators.required])
      this.otherSpeciality.updateValueAndValidity()

    } else {
      this.otherSpeciality.setValidators(null)
      this.otherSpeciality.updateValueAndValidity()

    }
  }
  /**
  * Compares password and confirm password are they same or not
  */
  comparePassword(control: any) {

    let password = control.get("password").value
    let confirmPassword = control.get("confirmPassword").value
    if (confirmPassword.length != '') {
      if (password !== confirmPassword) {
        control.get("confirmPassword").setErrors({ passwordCompare: true })
      }
      else {
        control.get("confirmPassword").setErrors(null)
      }
    }
    else {
      control.get("confirmPassword").setErrors({ invalid: true })
    }

  }

  // method check if  email is already in use
  checkEmail() {
    if (this.signupFormGroup.controls.email.status === "VALID") {

      let reqBody = {
        email: this.signupFormGroup.controls.email.value.toLowerCase()
      }
      this.apiService.apiRequest("post", "user/getUserByEmail", reqBody).subscribe((res) => {
        if (res.status == "success") {
          this.signupFormGroup.controls["email"].setErrors({ isEmailExist: true });
        }
        else {
          this.signupFormGroup.controls["email"].setErrors(null);
        }
      }, (err) => {

      }
      )
    }
  }

  // method check if license numbr is already in use
  checkLicenseNumber() {
    if (this.signupFormGroup.controls.licenseNumber.status === "VALID") {

      let reqBody = {
        licenseNumber: this.signupFormGroup.controls.licenseNumber.value
      }
      this.apiService.apiRequest("post", "user/getUserByLicenseNumber", reqBody).subscribe((res) => {
        if (res) {
          this.signupFormGroup.controls["licenseNumber"].setErrors({ isLicenseNumberExist: true });
        }
        else {
          this.signupFormGroup.controls["licenseNumber"].setErrors(null);
        }
      }, (err) => {

      }
      )
    }
  }
  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').match(/\s/g)
    const isValid = !isWhitespace
    return isValid ? null : { 'whitespace': true }
  }

  //method to check and uncheck given password conditions
  checkPassword = debounce(() => {

    let password = this.passwordFormGroup.controls.password.value

    if (this.oneNumericRegex.test(password)) {
      this.oneNumeric.checked = true
    } else {
      this.oneNumeric.checked = false

    }

    if (password.length >= 8) {
      this.minLength.checked = true;
    } else {
      this.minLength.checked = false;
    }

    if (this.lowerCaseRegex.test(password)) {
      this.lowerCase.checked = true
    } else {
      this.lowerCase.checked = false
    }

    if (this.upperCaseRegex.test(password)) {
      this.upperCase.checked = true
    } else {
      this.upperCase.checked = false

    }

    if (this.oneSymbol.test(password)) {
      this.symbol.checked = true
    } else {
      this.symbol.checked = false

    }

  }, 350)

  openTermsAndDocument() {
    this.dialog.open(TermsComponent).afterClosed().subscribe(response => {
      if (response == 'Accept') {

        let userDetails = {

          password: this.passwordFormGroup.value.password,
          "isAgreementAccepted": true,
          "userId": this.userId
        }
        this.Utility.setSpinner(true);
        this.apiService.apiRequest("post", "user/setupPassword", userDetails)
          .subscribe((res) => {
            this.Utility.setSpinner(false);
            let userData = res.data.userDetails

            // // Store the values in local storage
            localStorage.setItem("endUserEmail", userData.email)
            localStorage.setItem("endUserId", userData._id)
            localStorage.setItem("endUserType", userData.userType)
            localStorage.setItem("endUserFullName", userData.firstName + ' ' + userData.lastName)
            localStorage.setItem("endUserFirstName", userData.firstName)
            localStorage.setItem("accessToken", userData.accessToken)
            localStorage.setItem("endUserLastName", userData.lastName)
            localStorage.setItem("contactNumber", userData.contactNumber)
            localStorage.setItem("profilePic", userData.profilePic)

            this.Utility.openSnackBar(res.data.message, "Ok")
            this.router.navigate(['specialist/dashboard']);
          }, (err) => {
            this.Utility.openSnackBar("Something went wrong.", "Ok")
            this.Utility.setSpinner(false);

          })
      } else {
        this.router.navigate(['specialist']);
      }
    });
  }

  checkOtherOption(event) {
    let state = event.value

    if (state == 'Other') {
      this.signupFormGroup.controls["otherLicenseState"].setValidators([Validators.required, Validators.pattern(/^([a-zA-Z0-9]+\s)*[a-zA-Z0-9]+$/)])
      this.signupFormGroup.controls["otherLicenseState"].updateValueAndValidity();


    } else {
      this.signupFormGroup.controls["otherLicenseState"].setValidators(null);
      this.signupFormGroup.controls["otherLicenseState"].updateValueAndValidity();
    }
  }
}






